import initI18next from '../i18next.init';

await initI18next();
